<template>
  <div class="content">
    <!-- 搜索条件 -->
    <div class="block block-form">
      <div class="block-tilte">我的好友</div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item label="推荐人ID">
          <el-input v-model="searchForm.parentSourceId" placeholder="请输入推荐人ID" />
        </el-form-item>
        <el-form-item label="会员ID">
        <el-input v-model="searchForm.sourceId" placeholder="请输入会员ID" />
        </el-form-item>
        <el-form-item label="下单次数">
          <el-input v-model="searchForm.orderCountMix" placeholder="最小下单次数" style="width: 150px;" />
          <span style="padding: 0 5px;">至</span>
          <el-input v-model="searchForm.orderCountMax" placeholder="最大下单次数" style="width: 150px;" />
        </el-form-item>
        <el-form-item label="注册日期">
          <date-picker type="date" placeholder="开始日期" v-model="searchForm.createStartTime" style="width: 150px;">
          </date-picker>
          <span style="padding: 0 5px;">至</span>
          <date-picker type="date" placeholder="结束日期" v-model="searchForm.createEndTime"
            style="width: 150px;"></date-picker>
        </el-form-item>
<!--        <el-form-item label="是否为总监" v-if="!isBasic">-->
<!--          <radio-group v-model="searchForm.isMajor">-->
<!--            <radio label="">-->
<!--              <span>不限</span>-->
<!--            </radio>-->
<!--            <radio label="1">-->
<!--              <span>是</span>-->
<!--            </radio>-->
<!--            <radio label="0">-->
<!--              <span>否</span>-->
<!--            </radio>-->
<!--          </radio-group>-->
<!--        </el-form-item>-->
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button @click="onFormExport">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>


    <div class="block block-top">
      <Table border :columns="columns" :data="list" :loading="listLoading">
        <template slot-scope="{ row }" slot="action">
          <div class="div-flex">
            <span class="color-ff4" style="cursor: pointer" v-if="!isBasic" @click="showDetail(row)">查看详细资料</span>
            <span class="color-ff4" style="cursor: pointer" @click="toOrder(row)">查看订单</span>
<!--            <span class="color-ff4" style="cursor: pointer" v-if="!isBasic && row.isMajor == 0"-->
<!--              @click="setDirector(row)">设为总监</span>-->
            <span class="color-ff4" style="cursor: pointer" v-if="!isBasic && row.isMajor == 1"
              @click="cancelDirector(row)">取消总监</span>
<!--            <span class="color-ff4" style="cursor: pointer" @click="createQrcode(row)">生成二维码</span>-->
          </div>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.pageNo" show-sizer show-elevator show-total @on-change="changePage"
          @on-page-size-change="changePageSize"></Page>
      </div>
    </div>
    <SetDirector ref="SetDirector" @refresh="getList(true)"></SetDirector>
    <CancelDirector ref="CancelDirector" @refresh="getList(true)"></CancelDirector>
    <CreateQrcode ref="CreateQrcode"></CreateQrcode>
    <Detail ref="Detail"></Detail>
  </div>
</template>
<script>
import { getPlatformUuid, getIsBasic } from '@/utils/auth'
import { Icon, Table, Page, Button, Select, Option, Input, DatePicker, RadioGroup, Radio } from 'view-design'
import SetDirector from '@/views/pc/official/member/modal/SetDirector'
import CancelDirector from '@/views/pc/official/member/modal/CancelDirector'
import CreateQrcode from '@/views/pc/official/member/modal/CreateQrcode'
import Detail from '@/views/pc/official/member/modal/Detail'
import member from '@/javaApi/member'
import { formatDate } from '@/utils/date.js'
const memberModel = new member()
export default {
  name: 'Member',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker,
    RadioGroup,
    Radio,
    SetDirector,
    CancelDirector,
    CreateQrcode,
    Detail
  },
  data() {
    return {
      columns: [
        {
          title: 'ID',
          key: 'sourceId'
        },
        {
          title: '微信名',
          key: 'nickName',
          ellipsis: true,
          render: (h, params) => {
            let nickname = params.row.nickName
            let avatar = params.row.headPic
            let renderData = []
            if (avatar) {
              renderData.push(
                h('img', {
                  attrs: {
                    src: avatar,
                    width: 20
                  },
                })
              )
            }
            renderData.push(
              h('span', {}, nickname)
            )
            return renderData
          }
        },
        {
          title: '推荐人ID',
          key: 'parentSourceId'
        },
        {
          title: '下单次数',
          key: 'orderCount'
        },
        {
          title: '注册时间',
          key: 'createTime',
        },
        {
          title: '最后下单时间',
          key: 'lastOrderTimeStr',
          width: 150,
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 260,
        }
      ],
      listLoading: false,
      list: [
      ],
      total: 0,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        nickName: '',
        phone: '',
        parentSourceId: '',//推荐人id
        sourceId: '',//旧分站id
        createStartTime: '',
        createEndTime: '',
        orderCountMix: '',
        orderCountMax: '',
        isMajor: '',
        platformUuid: getPlatformUuid()
      },
      isBasic: getIsBasic() === 'true' ? true : false
    }
  },
  created() {
    this.getList(true)
  },
  computed: {
  },
  methods: {
    getList() {
      let searchForm = Object.assign({}, this.searchForm)
      this.listLoading = true
      searchForm.createStartTime = searchForm.createStartTime ? searchForm.createStartTime + ' 00:00:00' : ''
      searchForm.createEndTime = searchForm.createEndTime ? searchForm.createEndTime + ' 23:59:59' : ''
      memberModel.getUserList(searchForm).then(response => {
        let res = response.data
        if (res.code != 200) {
          this.$message.error(res.message)
          return
        }
        this.listLoading = false
        this.list = res.data.list || []
        this.total = res.data.total
      }).catch(error => {
        that.listLoading = false
        this.$message.error(error)
      })
    },
    onFormSearch() {
      this.searchForm.pageNo = 1
      // 时间格式转换
      this.searchForm.createStartTime = this.filterTime(this.searchForm.createStartTime)
      this.searchForm.createEndTime = this.filterTime(this.searchForm.createEndTime)
      this.getList()
    },
    onFormReset() {
      this.searchForm.nickName = ''
      this.searchForm.phone = ''
      this.searchForm.parentSourceId = ''
      this.searchForm.sourceId = ''
      this.searchForm.createStartTime = ''
      this.searchForm.createEndTime = ''
      this.searchForm.createEndTime = ''
      this.searchForm.orderCountMix = ''
      this.searchForm.orderCountMax = ''
      this.searchForm.isMajor = ''
      this.getList()
    },
    changePage(value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    changePageSize(value) {
      this.searchForm.pageSize = value;
      this.getList()
    },
    //查看订单
    toOrder(row) {
      this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 3)
      this.$router.push({ path: '/pc/official/order', query: { nick_name: row.nickName } })
    },
    //设为总监
    setDirector(row) {
      let param = {
        uuid: row.uuid
      }
      memberModel.userQueryJunior(param).then(response => {
        let res = response.data
        if (res.code == 200) {
          // 1 ：用户无推荐人 2：用户有推荐人但无下级 3：用户有推荐人且有下级
          if (res.data == 3) {
            row.isHasNextLevel = 1
          }
          this.$refs.SetDirector.init(true, row)
        } else {
          let message = res.message ? res.message : '系统繁忙请稍后再试！'
          this.$message.error(message)
        }
      }).catch(error => {
        this.$message.error('系统繁忙请稍后再试')
      })
    },
    //取消总监
    cancelDirector(row) {
      this.$refs.CancelDirector.init(true, row)
    },
    //查看详细资料
    showDetail(row) {
      this.$refs.Detail.init(true, row)
    },
    //生成二维码
    createQrcode(row) {
      this.$refs.CreateQrcode.init(true, row)
    },
    onFormExport: function () {
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.pageNo = 1
      searchForm.pageSize = 50000
      searchForm.createStartTime = searchForm.createStartTime ? searchForm.createStartTime + ' 00:00:00' : ''
      searchForm.createEndTime = searchForm.createEndTime ? searchForm.createEndTime + ' 23:59:59' : ''
      memberModel.getUserList(searchForm).then(response => {
        let res = response.data
        if (res.code != 200) {
          this.$message.error(res.message)
          return
        }
        let filename = "会员列表" + formatDate("yyMMddhhmmss")
        let header = ['id', '微信名', '推荐人ID', '下单次数', '注册时间', '最后下单时间']
        let data = res.data.list.map(x => {
          return [x.id, x.nickName, x.parentSourceId, x.orderCount, x.createTime, x.lastOrderTimeStr]
        })
        import('@/vendor/Export2Excel').then(excel => {
          excel.export_json_to_excel({
            header,
            data,
            filename
          })
          this.$message.success('导出成功')
        })
      }).catch(error => {
        this.$message.error(error)
      })
    },
    // 时间格式转换
    filterTime(time) {
      if (time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        var d = date.getDate()
        d = d < 10 ? '0' + d : d
        var h = date.getHours()
        h = h < 10 ? '0' + h : h
        var minute = date.getMinutes()
        minute = minute < 10 ? '0' + minute : minute
        var s = date.getSeconds()
        s = s < 10 ? '0' + s : s
        return y + '-' + m + '-' + d
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .table-wrapper {
  margin-top: 30px;
}

.search-wrap .ivu-icon-ios-arrow-down:before {
  color: #232323;
  content: "\F33D";
}

.ivu-date-picker-rel {
  margin: 11px 0;
}

.ivu-table {
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
}

.table-wrapper .ivu-table-header th {
  background-color: #FCFAF8 !important;
}

.table-wrapper .ivu-table-header th .ivu-table-cell {
  color: #222222 !important;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border: none;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 0px;
  border-color: #FFFFFF !important;
}

.div-flex {
  display: flex;
  flex-wrap: wrap;
}

.div-flex .color-ff4 {
  width: 50%;
}

.block-tilte {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  margin-bottom: 24px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/member/Index.vue